import { createSelector } from 'reselect'

import { RootState } from './store'

const getAppState = (state: RootState) => state?.app

export const getAppIsLdInitialized = createSelector(getAppState, (appState) => appState?.isLdInitialized)

export const getRiskAlertTaskId = createSelector(getAppState, (appState) => appState?.riskAlertTaskId ?? null)
export const getActiveOpenItemsTab = createSelector(getAppState, (appState) => appState?.activeOpenItemsTab)
